export default {
  title: "Proof of presence required",
  content:
    "You must scan a known <b class='text-info'>Identifier</b> of the <b class='text-info'>{entity}</b> in order to perform this action.",
}
